import React from 'react';
import styled from 'styled-components';
import Button from '../Components/Button';
import { RECEIVER_ACTIONS, SENDER_ACTIONS } from '../models/Engine';
import { InventoryProduct } from '../models/Inventory';
import { PageType } from '../models/PageData';

const Wrapper = styled.section`
  padding: 48px;
  overflow-y: auto;
  h1 {
    font-size: 32px;
    text-align: center;
  }
  .products {
    margin-top: 48px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 12px;
  }
  .action-container {
    position: relative;
    z-index: 100;
    button {
      width: 100%;
      font-size: 24px;
      padding: 18px 4px;
    }
  }
`;

const Card = styled.div`
  border: 1px solid grey;
  border-radius: 8px;
  .product-info {
    background-color: white;
    padding: 16px;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }
  img {
    width: 100%;
  }
`;

const AdminVend: React.FC = () => {
  const products = window.DATA.products as InventoryProduct[];

  const handleClick = (productId: string) => {
    window.SENDER({ type: SENDER_ACTIONS.VEND, payload: productId });
  };

  return (
    <Wrapper>
      <h1>SELECT PRODUCT</h1>
      <div className="products">
        <Card onClick={() => handleClick('RAND')}>
          <div className="product-info">
            <h4 style={{ color: 'blue' }}>RANDOM PRODUCT</h4>
            <p>Sselect to vend from a random channel</p>
          </div>
        </Card>
        {(products as InventoryProduct[]).map((el) => (
          <Card key={el.id} onClick={() => handleClick(el.id)}>
            <div className="product-info">
              <h4>{el.name}</h4>
              <p>{el.description}</p>
            </div>
          </Card>
        ))}
      </div>
      <div className="action-container">
        <Button onClick={() => window.RECEIVER({ type: RECEIVER_ACTIONS.CHANGE_PAGE, payload: { page: PageType.SCREEN_ADMIN } })}>BACK</Button>
      </div>
    </Wrapper>
  );
};
export default AdminVend;
